import { Box, Button, ModalProps, Text } from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import useTranslate from '../hooks/useTranslate';
import useUnstakeFancyBear from '../hooks/useUnstakeFancyBear';
import FancyBearImage from './FancyBearImage';
import RefreshCountdown from './RefreshCountdown';
import SimplePopup from './SimplePopup';

type UnstakePopupProps = Omit<ModalProps, 'children'> & {
  tokenId: number;
};

const UnstakePopup = ({ tokenId, ...rest }: UnstakePopupProps) => {
  const translate = useTranslate();
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = useCallback(() => {
    setIsSuccess(true);
  }, []);

  const [unstake, isLoading] = useUnstakeFancyBear(tokenId, handleSuccess);

  return (
    <SimplePopup
      size="md"
      title={translate('unstakePopup:title')}
      description={translate('unstakePopup:description')}
      isClosable={!isLoading}
      {...rest}
    >
      <FancyBearImage tokenId={tokenId} mt="4" />

      {isSuccess ? (
        <Box mt="6" borderRadius="lg" bg="dark.800">
          <Text
            fontSize="sm"
            opacity="0.8"
            textAlign="center"
            p="3"
            maxW="20em"
            m="0 auto"
          >
            {translate('common:waitMessage')}
          </Text>

          <RefreshCountdown seconds={10} borderTopRadius="0" />
        </Box>
      ) : (
        <Button w="full" mt="6" onClick={unstake} isLoading={isLoading}>
          {translate('unstakePopup:confirm', { tokenId })}
        </Button>
      )}
    </SimplePopup>
  );
};

export default UnstakePopup;
